import { render } from "./PDFviewer.vue?vue&type=template&id=0a7a626a&scoped=true&ts=true"
import script from "./PDFviewer.vue?vue&type=script&lang=ts"
export * from "./PDFviewer.vue?vue&type=script&lang=ts"

import "./PDFviewer.vue?vue&type=style&index=0&id=0a7a626a&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7a626a"]])

export default __exports__